export const uberStoreStatusCodes = {
  storeOnline: "ONLINE",
  storePaused: "PAUSED",
};
